import { Injectable } from '@angular/core';

@Injectable()
export class IdService {
  /** Service constructor */
  constructor() {}
}
